import { useQuery } from '@tanstack/react-query'

import { downloadBankTransfersCsv } from '@src/api'
import { DefaultApiDownloadBankTransfersCsvRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchDownloadBankTransfersCsv = (
  params: DefaultApiDownloadBankTransfersCsvRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: false,
    queryFn: () => downloadBankTransfersCsv(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.DOWNLOAD_BANK_TRANSFERS_CSV],
  })
}
